export const SKILLS_VISIBLE_COUNT = 2;

export const formatDate = (iso) => {
    if (!iso) return "N/A";
    const d = new Date(iso);
    return d.toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" });
};

export const getDaysFromToday = (dateString) => {
    if (!dateString) return null;
    const targetDate = new Date(dateString);
    const today = new Date();
    targetDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    const diffDays = Math.round((targetDate - today) / (1000 * 60 * 60 * 24));
    if (diffDays === 0) return "Today";
    if (diffDays > 0) return `${diffDays} days from now`;
    return `${Math.abs(diffDays)} ${Math.abs(diffDays) === 1 ? "day" : "days"}`;
};

export const downloadResume = async (c) => {
    if (!c?.resume_url) return;
    try {
        const url = c.resume_url;
        const filename = url.split("/").pop().split("?")[0] || "resume";
        const response = await fetch(url);
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
        console.error("Resume download failed:", err);
    }
};

export const PAGE_LIMIT = 10;

export const renderCustomPagination = (totalPages, currentPage, setCurrentPage) => {
    if (totalPages <= 1) return null;
    const pages = [];

    pages.push(
        <button className="cv-page-btn" key="prev" onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}>
            ‹
        </button>
    );

    pages.push(
        <button key={1} className={`cv-page-btn${currentPage === 1 ? " active" : ""}`} onClick={() => setCurrentPage(1)}>
            1
        </button>
    );

    if (currentPage > 3) {
        pages.push(<span key="left-dots" className="cv-page-ellipsis">…</span>);
    }

    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, currentPage + 1);
    for (let i = start; i <= end; i++) {
        pages.push(
            <button key={i} className={`cv-page-btn${currentPage === i ? " active" : ""}`} onClick={() => setCurrentPage(i)}>
                {i}
            </button>
        );
    }

    if (currentPage < totalPages - 2) {
        pages.push(<span key="right-dots" className="cv-page-ellipsis">…</span>);
    }

    if (totalPages > 1) {
        pages.push(
            <button key={totalPages} className={`cv-page-btn${currentPage === totalPages ? " active" : ""}`} onClick={() => setCurrentPage(totalPages)}>
                {totalPages}
            </button>
        );
    }

    pages.push(
        <button className="cv-page-btn" key="next" onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages}>
            ›
        </button>
    );

    return pages;
};
